import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import {SlackAuthBanner} from 'shells/form/slack/slack-auth-banner';

import type {SalesAutomationStage as SalesAutomationStageFragment} from 'nutshell-graphql-types';

import {OPEN_LEAD_SLACK} from '../../constants';

import {calculateBoardWidth} from '../calculate-board-width';
import {StageCardsSlackMessagesContainer} from '../card-containers/stage-cards-slack-messages-container';

import {CollapsibleSection} from './collapsible-section';

type OwnProps = {
    stages: SalesAutomationStageFragment[];
    hasSlackIntegration: boolean | null | undefined;
    hideCards: boolean;
};

type Props = OwnProps;

/*
 * Top-level component responsible for rendering the entire "goals"
 * section (row) on the sales automation setup board.
 */
export class SalesAutomationSlack extends React.PureComponent<Props> {
    render() {
        const boardWidth = calculateBoardWidth(this.props.stages.length);

        return (
            <DragDropContext onDragEnd={() => {}}>
                <CollapsibleSection type={OPEN_LEAD_SLACK}>
                    {this.props.hasSlackIntegration ? (
                        this.props.stages.map((stage) => {
                            return (
                                <StageCardsSlackMessagesContainer
                                    key={stage.id}
                                    hideCards={this.props.hideCards}
                                    parentId={stage.id}
                                />
                            );
                        })
                    ) : (
                        <SlackAuthBanner
                            width={boardWidth}
                            text='Connect with Slack to update your team when leads are won, or when they enter a particular stage'
                        />
                    )}
                </CollapsibleSection>
            </DragDropContext>
        );
    }
}
